import React, {useState} from "react";
import { Button, Checkbox, Control, Field, Input, TextArea } from "@allxsmith/bestax-bulma";
import {formatDate, readableDate} from "../../utils";

export default function VehicleRentalRow({value, index, onVehicleSave, onRentalSave, onChange, onQcCheck, view, getMissingOffHireItems, onMultiChange}){
  const [editable, setEditable] = useState(false);
  const [qcEditable, setQcEditable] = useState(false);
    const getHighlightColor = (value) => {
        if (view === 'onhires' && (!value.on_hire_insurance_completed || !value.on_hire_tracker_completed)) {
          return "table-highlight-orange";
        }
        if (view === 'offhires') {
          const incompleteOffHire = !value.off_hire_insurance_completed || !value.off_hire_tracker_completed;
          const isPastOffHireDate = value.off_hire_date && new Date(value.off_hire_date) < new Date();
          if (incompleteOffHire && isPastOffHireDate) {
            return "table-highlight-red";
          }
        }
        return "";
    }

    const getRate = (rental) => {
          if(rental.rental_type === "LT"){
              // This does not account for leap years, this is not good but roger does not mind it being inaccurate
              let rate = rental.long_term_daily
              return "£"+rate
          }
          else if(rental.rental_type === "ST"){
              if(rental.rate_card && rental.rate_card.id){
                  let rate = rental.rate_card.day_28_plus_rate
                  return "£"+rate
              }
              else{
                  return "No Rate Card"
              }
          }
    }

    const handleQuoteReceivedTick = e => {
        let data = {[e.target.name]: e.target.checked};
        if(e.target.checked){
            data['date_of_quote_received'] = formatDate(new Date());
        }
        else{
            data['date_of_quote_received'] = ''
        }
        onMultiChange(data, index);
    }

    const handleVehicleSave = () => {
        onVehicleSave(index);
        setQcEditable(false);
    }

    const handleRentalSave = () => {
        onRentalSave(index);
        setEditable(false);
    }

    return (
      <tr
              className={`clickable ${getHighlightColor(value)}`}
              onClick={() => window.open(`/editrental/${value.id}`, "_self")}
              key={value.id}
            >
        <td>{value.id}</td>
        <td>{value.vehicle.registration}</td>
        <td>{value.rental_type === 'ST' ? 'SHORT TERM' : value.rental_type === "LT"? 'LONG TERM' : "FREE OF CHARGE"}</td>
        <td>{value.is_tracker_hire ? "YES" : "NO"}</td>
        <td>{readableDate(value.chargeable_date)}</td>
        <td>{readableDate(value.finish_date)}</td>
        <td>{value.customer.display_name}</td>
        <td>{value.vehicle.make.name}</td>
        <td>{value.vehicle.model.name}</td>
        <td>{value.vehicle.type.name}</td>
        {view !== "awaiting_quote" && <td>{getRate(value)} </td>}
        {view !== "awaiting_quote" && <td>£{value.vehicle.finance_payment}</td>}
        {view !== "awaiting_quote" && <td>{value.rate_card ? value.rate_card.name : value.rental_type === "LT" ? "LONG TERM RATE CARD" : "NO RATE CARD"}</td>}
        {view !== "awaiting_quote" && <td>{value.invoice_interval}</td>}
        <td>{value.comments} </td>
        {view === "unfinished_off" &&
            <td onClick={e => e.stopPropagation()}>
                <Field className={"has-addons"}>
                    <Control>
                        <TextArea
                            name={"off_hire_comments"}
                            value={value.off_hire_comments}
                            disabled={!editable}
                            onChange={e => onChange(e, index)}
                        />
                    </Control>
                    {editable ? (<Control>
                    <Button
                      className="small-row-white"
                      color="success"
                      onClick={handleRentalSave}
                    >
                      S
                    </Button>
                  </Control>
                ) : (
                  <Control>
                    <Button
                      className="small-row-black"
                      onClick={() => setEditable(!editable)}
                    >
                      E
                    </Button>
                  </Control>)}
                </Field>
            </td>
        }
        {view === "unfinished_off" && <td>{getMissingOffHireItems(value)}</td>}
        {view === "awaiting_quote" && <td>{readableDate(value.date_of_damage_indicated)}</td>}
        {view === "awaiting_quote" &&
            <td onClick={e => e.stopPropagation()}>
                <Field className={"has-addons"}>
                    <Control>
                        <Checkbox
                            name={"quote_received"}
                            checked={value.quote_received}
                            disabled={!editable}
                            onChange={handleQuoteReceivedTick}
                        />
                    </Control>
                    {editable ? (<Control>
                    <Button
                      className="small-row-white"
                      color="success"
                      onClick={handleRentalSave}
                    >
                      S
                    </Button>
                  </Control>
                ) : (
                  <Control>
                    <Button
                      className="small-row-black"
                      onClick={() => setEditable(!editable)}
                    >
                      E
                    </Button>
                  </Control>)}
                </Field>
            </td>
        }
        {view === "awaiting_quote" &&
            <td onClick={e => e.stopPropagation()}>
                <Field className={"has-addons"}>
                    <Control>
                        <Input
                            name={"date_of_quote_received"}
                            type={"date"}
                            value={value.date_of_quote_received}
                            disabled={!editable}
                            onChange={e => onChange(e, index)}
                        />
                    </Control>
                    {editable ? (<Control>
                    <Button
                      className="small-row-white"
                      color="success"
                      onClick={handleRentalSave}
                    >
                      S
                    </Button>
                  </Control>
                ) : (
                  <Control>
                    <Button
                      className="small-row-black"
                      onClick={() => setEditable(!editable)}
                    >
                      E
                    </Button>
                  </Control>)}
                </Field>
            </td>
        }
        {view === "awaiting_quote" &&
            <td onClick={e => e.stopPropagation()}>
                <Field className={"has-addons"}>
                    <Control>
                        <Input
                            type={"number"}
                            name={"quote_amount"}
                            value={value.quote_amount}
                            disabled={!editable}
                            onChange={e => onChange(e, index)}
                        />
                    </Control>
                    {editable ? (<Control>
                    <Button
                      className="small-row-white"
                      color="success"
                      onClick={handleRentalSave}
                    >
                      S
                    </Button>
                  </Control>
                ) : (
                  <Control>
                    <Button
                      className="small-row-black"
                      onClick={() => setEditable(!editable)}
                    >
                      E
                    </Button>
                  </Control>)}
                </Field>
            </td>
        }
        <td onClick={e => e.stopPropagation()}>
            <Field className={"has-addons"}>
                <Control>
                    <Checkbox
                        checked={value.vehicle.qc_check_received}
                        name={"qc_check_received"}
                        onChange={e => onQcCheck(e, index)}
                        disabled={!qcEditable}
                    />
                </Control>
                {qcEditable ? (<Control>
                    <Button
                      className="small-row-white"
                      color="success"
                      onClick={handleVehicleSave}
                    >
                      S
                    </Button>
                  </Control>
                ) : (
                  <Control>
                    <Button
                      className="small-row-black"
                      onClick={() => setQcEditable(!qcEditable)}
                    >
                      E
                    </Button>
                  </Control>)}
            </Field>
        </td>
      </tr>
    );


}